export default __webpack_public_path__ + "static/media/Untitled-1-01.44a24ceb.png";